module.exports = __webpack_public_path__ + "media/CN_002.56f14bcb.mp3";